import { httpClient } from './http-client';
import type { ApiResponse } from './api.types';

export interface PresupuestoDto {
  id: string;
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface PresupuestoInputDto {
  empresaId: string;
  codigo: string;
  nombre: string;
  esVisible?: boolean;
}

export const presupuestosService = {
  getAll: (empresaId: string): Promise<ApiResponse<PresupuestoDto[]>> =>
    httpClient.get('/presupuestos', { empresaId }),

  getById: (id: string): Promise<ApiResponse<PresupuestoDto>> =>
    httpClient.get(`/presupuestos/${id}`),

  create: (data: PresupuestoInputDto): Promise<ApiResponse<PresupuestoDto>> =>
    httpClient.post('/presupuestos', data),

  update: (id: string, data: PresupuestoInputDto): Promise<ApiResponse<PresupuestoDto>> =>
    httpClient.put(`/presupuestos/${id}`, data),

  delete: (id: string): Promise<ApiResponse<void>> =>
    httpClient.delete(`/presupuestos/${id}`),
};
